import { List, P, Strong } from '@ahmdigital/ui';

import { ambulanceIntro, dependantsExcess } from './shared';

export default {
  intro: {
    accidentOverrideDescription: (
      <>
        <P>All bronze inclusions plus some extra good stuff:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
          <li>
            <Strong>Dental surgery</Strong>
          </li>
          <li>
            <Strong>Lung and chest</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    description: (
      <>
        <P>All bronze inclusions plus some extra good stuff:</P>
        <List variant={['inside', 'withBottomMargin']}>
          <li>
            <Strong>Sleep studies</Strong>
          </li>
          <li>
            <Strong>Dental surgery</Strong>
          </li>
          <li>
            <Strong>Lung and chest</Strong>
          </li>
          <li>{dependantsExcess}</li>
          <li>
            <Strong>Unlimited medically necessary ambulance^</Strong>
          </li>
        </List>
      </>
    ),
    disclaimer: ambulanceIntro.featureDisclaimer,
  },
};
